import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ChatState } from "./chat.models";

export const selectChatState = createFeatureSelector<ChatState>('chat');

export const selectChat = createSelector(
  selectChatState,
  state => state.data
);

export const selectAllChats = createSelector(
  selectChatState,
  state => state.allData
);

export const selectChatPagination = createSelector(
  selectChatState,
  state => state.pagination
);

export const selectChatHasMore = createSelector(
  selectChatState,
  state => state.pagination?.has_more ?? false
);

export const selectChatNextBeforeMessageId = createSelector(
  selectChatState,
  state => state.pagination?.next_before_message_id ?? null
);

export const selectChatLoadingOlder = createSelector(
  selectChatState,
  state => state.loadingOlder
);

export const selectChatUploadingAttachment = createSelector(
  selectChatState,
  state => state.uploadingAttachment
);

export const selectChatError = createSelector(
  selectChatState,
  state => state.error
);

export const selectChatMessage = createSelector(
  selectChatState,
  state => state.message
);

export const selectChatSuccess = createSelector(
  selectChatState,
  state => state.success
);

export const selectChatValidationError = createSelector(
  selectChatState,
  state => state.validationError
);
